import React from "react";

import ConverterContainer from "../../components/converter/converterContainer";

const MainPage = () => {
  return (
    <div className="container">
      <div>
        <ConverterContainer />
      </div>
    </div>
  );
};

export default MainPage;
